<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="#231F20"
      d="M6.86.25a6.11 6.11 0 10-.001 12.218 6.11 6.11 0 000-12.218zm0 1.5a4.61 4.61 0 110 9.218 4.61 4.61 0 010-9.218z"
    />
    <path
      fill="#231F20"
      d="M10.376 9.876a.75.75 0 01.976-.073l.085.073 4.156 4.156a.75.75 0 01-.977 1.133l-.084-.072-4.156-4.156a.75.75 0 010-1.061zM6.9 3.675c.314 0 .574.231.618.533l.007.092v4a.625.625 0 01-1.243.092L6.275 8.3v-4c0-.345.28-.625.625-.625z"
    />
    <path
      fill="#231F20"
      d="M8.9 5.675a.625.625 0 01.092 1.243l-.092.007h-4a.625.625 0 01-.092-1.243l.092-.007h4z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconZoom',
};
</script>

<style></style>
